import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import getFilteredDealerOrders from '@app/selectors/get-filtered-dealer-orders';
import { toggleFilter } from '@app/actions/dealers';
import {
  startFetchingTickets,
  assignTicketToCurrentUser,
  unAssignTicketToCurrentUser,
  fetchMoreFinalizedTickets,
  dismissOrder,
  cancelDelivery,
  setCurrentOrder,
} from '@app/actions/orders';
import getFinalizedOrders from '@chama/utils/selectors/finalized-orders';
import OrdersLayout from '../components/OrdersLayout';

const mapStateToProps = state => {
  const {
    dealer,
    auth: { chamaID },
  } = state;
  const order = state.orders.dict[state.orders.currentOrderId];
  const dealers = state.dealer.all;
  const notification = state.notifications.current;
  const { isFetching } = dealer;
  const {
    time: { offset },
  } = state;

  const orderCompareNewestOnTop = (
    { currentTicket: currentTicketA },
    { currentTicket: currentTicketB },
  ) => {
    // TODO: fix & enable
    // eslint-disable-next-line no-nested-ternary
    return currentTicketA.modificationTime > currentTicketB.modificationTime
      ? -1
      : currentTicketA.modificationTime < currentTicketB.modificationTime
      ? 1
      : 0;
  };

  const filteredOrders = getFilteredDealerOrders(state);

  const ordersFinalized = getFinalizedOrders(filteredOrders).sort(orderCompareNewestOnTop);

  return {
    dealers,
    order,
    ordersFinalized,
    notification,
    offset,
    isFetchingDealer: isFetching,
    ticketsFetched: state.orders.fetched,
    oldTerms: dealer.termsAndConditions,
    isDealerFetched: !!(dealers && dealers.length > 0),
    userId: chamaID,
  };
};

class Orders extends Component {
  componentWillMount() {
    this.props.startFetchingTickets();
  }

  render() {
    return <OrdersLayout {...this.props} />;
  }
}
Orders.propTypes = {
  startFetchingTickets: PropTypes.func,
};
Orders.defaultProps = {
  startFetchingTickets: Function.prototype,
};

export default withRouter(
  connect(mapStateToProps, {
    startFetchingTickets,
    assignTicketToCurrentUser,
    unAssignTicketToCurrentUser,
    fetchMoreFinalizedTickets,
    dismissOrder,
    cancelDelivery,
    toggleFilter,
    setCurrentOrder,
  })(Orders),
);



// WEBPACK FOOTER //
// ./src/modules/orders/containers/Orders.jsx